import React, { useEffect } from 'react'
import { Container, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BannerMainImageSection from '../../bannerMainImageSection'
import withLocation from '../../withLocation'
import { connect, useDispatch } from 'react-redux'
import ContactUsDialog from '../../dialog/contactUsDialog'
import { OnCancelSelectedEstimate } from '../../../actions/proceedEstimateActions'
import { ImageBase64 } from '../../image/image'
import Layout from '../../../layout'
import InformationBlock from '@mmsg/louie/dist/InformationBlock/InformationBlock'
import { AlertBlockComponent, PrimaryButton } from '@mmsg/louie'
import { IVehicleProps, FinAppStatusValue } from 'application/utils/type'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
} from '../../../helpers'
import { fetchFinAppStatus } from 'application/actions/finAppStatusActions'
import globals from 'application/constants/globals'

interface IInputDataProps {
  match: { params: { estimateId: string } }
  isAuthenticated: boolean
  opportunityId: string
  estimate: {
    vehicle: IVehicleProps
    vehicleDescription: string
  }
  consultantFirstName: string
  userFirstName: string
}

interface IProceedEstimateStateProps {
  isCancelRequestSubmitting: boolean
  cancellationSubmittedForProceededEstimate: boolean
  hasCancelSubmissionFailed: boolean
  errorMsgOnCancelProceedEstimate: string
}

interface IStateProps {
  proceedEstimate: IProceedEstimateStateProps
  individualEstimate: {
    estimate: { vehicle: IVehicleProps }
  }
}

interface IInformationBlockDataProps {
  heading: string
  content: string
}

const ProceedEstimate = ({
  match,
  isAuthenticated,
  opportunityId,
  estimate,
  consultantFirstName,
  userFirstName,
}: IInputDataProps) => {
  let dispatch = useDispatch()

  let finAppNumber = useSelector(
    (state: any) => state.opportunity.financeapplicationnumber
  )

  useEffect(() => {
    if (isAuthenticated) {
      fireViewStartCustomEvent({
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:estimates:proceed' },
        },
      })
      if (document.getElementById('page')) {
        fireViewEndCustomEvent('#page', {
          detail: {
            eventType: 'page load',
            page: { pageName: 'maxxia:mylease:estimates:proceed' },
          },
        })
      }
    }
  }, [isAuthenticated, opportunityId])

  useEffect(() => {
    dispatch(fetchFinAppStatus(opportunityId,finAppNumber.toString()))
  }, )

  let finAppStatus = useSelector(
    (state: any) => state.finAppStatus && state.finAppStatus.status
  )
  let finAppUrl = useSelector(
    (state: any) => state.finAppStatus && state.finAppStatus.url
  )

  const GotoFinanceApplication = () => {
    window.open(finAppUrl, '_blank')
  }

  let history = useHistory()
  let notificationElement = document.getElementById('notification')
  if (notificationElement !== undefined && notificationElement !== null) {
    let notifElement = document.getElementById('notification')
    if (notifElement) notifElement.style.display = 'none'
  }
  let proceedEstimateState: IProceedEstimateStateProps = useSelector(
    (state: IStateProps) => state.proceedEstimate
  )
  let isSubmissionInProgress: boolean = useSelector(
    (state: IStateProps) =>
      state.proceedEstimate && state.proceedEstimate.isCancelRequestSubmitting
  )

  let isSparta: boolean = useSelector(
    (state: IStateProps) =>
      state.individualEstimate &&
      state.individualEstimate.estimate &&
      state.individualEstimate.estimate.vehicle &&
      !!state.individualEstimate.estimate.vehicle.id &&
      state.individualEstimate.estimate.vehicle.shadowPR
  )
  let spartaNotificationMsg: string =
    'If you were successful, ' +
    consultantFirstName +
    ' will be in touch soon to get your tick of approval on the proposal.'

  if (proceedEstimateState.cancellationSubmittedForProceededEstimate) {
    history.push('/estimates/' + match.params.estimateId + '/proceed/cancelled')
  }

  let spartaFirstContent: string =
    'If you haven’t already completed a finance application, you’ll receive an email from your consultant with a link to complete this step.'
  if (isSparta)
    spartaFirstContent +=
      " If you weren't successful, this application should still be usable for other available cars."

  let contactText = ''
  if (
    finAppStatus === FinAppStatusValue.COMPLETED ||
    finAppStatus === FinAppStatusValue.NONE
  )
    contactText =
      consultantFirstName +
      ' will be in touch to guide you through the next steps soon ' +
      userFirstName +
      '. Or, you could speed things along by contacting your consultant now.'

  const infoContent: IInformationBlockDataProps[] = [
    {
      heading: 'What’s next?',
      content: spartaFirstContent,
    },
    {
      heading: 'What you’ll need to have ready',
      content:
        'The form within the link requires details about your income, regular expenses and other financial information. If you have this information at the ready the form should only take 5-10 minutes to complete online.',
    },
  ]

  return (
    <Layout>
      <div id="page" className="proceed-estimate-page">
        <BannerMainImageSection imageName={globals.isBrandMX ? 'Banner2' : ''}>
          <div className="text-center">
            {!isSparta && (
              <>
                <img src="/images/icon-selected.svg" alt="" />
                <div className="mt-4 banner-content">
                  Congratulations {userFirstName}!
                </div>
              </>
            )}
            {isSparta && (
              <>
                <img src="/images/icon-road-white.svg" alt="" />
                <div className="mt-4 banner-content">
                  One step closer {userFirstName}!
                </div>
              </>
            )}
          </div>
        </BannerMainImageSection>

        {isSparta && (
          <AlertBlockComponent
            heading={spartaNotificationMsg}
            content=""
            extended={true}
            isWarning={true}
          />
        )}
        <Container className="section mb-5">
          {finAppStatus === FinAppStatusValue.NOTSTARTED ||
            (finAppStatus === FinAppStatusValue.STARTED && (
              <div className="text-center">
                <div className="mt-5 mb-3 text-center">
                  You’ll receive a confirmation email shortly. To speed things
                  up {userFirstName}, proceed onto the next step, which is to
                  complete a finance application.
                </div>

                {finAppUrl && (
                  <PrimaryButton onClick={GotoFinanceApplication}>
                    Start finance application
                  </PrimaryButton>
                )}
              </div>
            ))}

          <div className="mt-5 mb-3 text-center">
            We’ve let your consultant know you’d like to proceed with the
          </div>
          <h3 className="text-dark mb-3 text-center">
            {estimate && estimate.vehicle && estimate.vehicle.id && (
              <span>
                {estimate.vehicle.year} {estimate.vehicle.make}{' '}
                {estimate.vehicle.family}
              </span>
            )}
            {estimate && estimate.vehicle && !estimate.vehicle.id && (
              <span>{estimate.vehicleDescription}</span>
            )}
          </h3>
          {estimate && estimate.vehicle && estimate.vehicle.id && (
            <div className="text-center">{estimate.vehicleDescription}</div>
          )}

          <div className="car-image car-image-large mb-3 pb-0">
            {estimate &&
              estimate.vehicle &&
              estimate.vehicle.id &&
              estimate.vehicle.vehicleImage && (
                <ImageBase64
                  ImageBase64Encoded={estimate.vehicle.vehicleImage.base64Image}
                />
              )}
            {estimate &&
              (!estimate.vehicle ||
                !estimate.vehicle.id ||
                !estimate.vehicle.vehicleImage) && (
                <img src="/images/car-image-default.svg" alt="" />
              )}
          </div>
          <p className="text-smaller text-center">Image is indicative only</p>
          {finAppStatus === FinAppStatusValue.NONE && (
            <InformationBlock
              data={infoContent}
              headingFontWeight="600"
              descFontWeight="500"
            />
          )}

          <div className="mt-4 mb-5 text-center">{contactText}</div>

          <div className="text-center">
            {(finAppStatus === FinAppStatusValue.COMPLETED ||
              finAppStatus === FinAppStatusValue.NONE) && (
              <ContactUsDialog
                className="d-block mx-auto mt-3 mb-24 bg-brand"
                theme="button"
                size="lg"
                launchText="Contact my consultant"
              />
            )}
            {(finAppStatus === FinAppStatusValue.STARTED ||
              finAppStatus === FinAppStatusValue.NOTSTARTED) && (
              <ContactUsDialog
                variant="invertColor"
                extendInMob
                invertColor
                className="d-block mx-auto mt-3 mb-24"
                theme="button"
                size="lg"
                launchText="Contact my consultant"
              />
            )}
            <div className="font-weight-bold text-small">
              {!proceedEstimateState.cancellationSubmittedForProceededEstimate && (
                <>
                  {isSubmissionInProgress ? (
                    <a className="text-underline text-dark clickable">
                      <>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="mb-1"
                        />
                        Submitting your cancellation request...
                      </>
                    </a>
                  ) : (
                    <a
                      className="text-underline text-dark clickable"
                      onClick={() => {
                        OnCancelSelectedEstimate(
                          opportunityId,
                          match.params.estimateId,
                          dispatch
                        )
                        fireInteractionCustomEvent({
                          detail: {
                            eventType: 'custom link click',
                            data: {
                              category: 'button',
                              section: 'mylease',
                              text: 'cancel estimate',
                              label: 'cancel estimate',
                            },
                          },
                        })
                      }}
                      id="proceedestimate.cancellink"
                    >
                      Contact my consultant to cancel
                    </a>
                  )}

                  {proceedEstimateState.hasCancelSubmissionFailed &&
                    proceedEstimateState.errorMsgOnCancelProceedEstimate !==
                      '' && (
                      <div className="errorMsg show mt-2 mb-2">
                        {proceedEstimateState.errorMsgOnCancelProceedEstimate}
                      </div>
                    )}
                </>
              )}
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  )
}

function mapStateToProps(
  state: {
    authentication: { isAuthenticated: boolean; opportunityId: string }
    individualEstimate: { estimate: {} }
    consultant: { firstName: string }
    user: { firstName: string }
  },
  ownProps: any
) {
  const { isAuthenticated, opportunityId } = state.authentication
  const estimate = state.individualEstimate.estimate || {}
  const { firstName: consultantFirstName } = state.consultant
  const { firstName: userFirstName } = state.user

  return {
    isAuthenticated,
    opportunityId,
    estimate,
    consultantFirstName,
    userFirstName,
  }
}
export default connect(mapStateToProps)(withLocation(ProceedEstimate))
